import { css } from '@emotion/css';

export const tableActionCell = css`
  padding-top: 0 !important;
  padding-bottom: 0 !important;
`;

// Single source for the monospace stack — also fed into each app's antd `fontFamilyCode` token
// (see the app's ConfigProvider) so the token and this class never diverge. globalCss runs at
// module level (no runtime `token`), hence the constant. See .claude/rules/numeric-typography.md.
export const MONO_FONT_FAMILY = "'JetBrains Mono', SFMono-Regular, Consolas, 'Liberation Mono', Menlo, Courier, monospace";

// Monospace for identifiers/codes (SVNR, Auftragsnummer, Kurzname, …). See numeric-typography.md.
export const monoFont = css`
  font-family: ${MONO_FONT_FAMILY};
`;

// Equal-width digits for DISPLAYED numbers compared down a column or changing in place (tables,
// summaries, counters). Not for plain input fields. See .claude/rules/numeric-typography.md.
export const tabularNums = css`
  font-variant-numeric: tabular-nums;
`;
